import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { Button } from '@/shared/ui';

type Props = {
  onBack: () => void;
};

export const BackButton = ({ onBack }: Props) => {
  return (
    <Button variant="non-outline" size="none" onClick={onBack}>
      <ArrowLeftIcon />
    </Button>
  );
};
